// ----------------------------------------------------------------------

export default function Typography(theme) {
    return {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    toolbarButton: 'span',
                    label: 'span',
                },
            },
            styleOverrides: {
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
            },
        },
    };
}
